module.exports = __webpack_public_path__ + "img/logo-blue.3e038202.svg";